var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v(" 🚨 You do not have permission to see payment information. Please contact "),_c('span',{attrs:{"data-test-id":"billing-admins"}},[_vm._v(_vm._s(_vm.getBillingAdmins))]),_vm._v(" to get permission to view and edit your organizations’s payment information. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }